module.exports = __webpack_public_path__ + "static/the-emperor-of-all-maladies-8dd4f07037cd3ed2310bc1d7a13ab46e.jpg";